<template>
	<div class="steps flex rounded-md">
		<div class="rounded-lg border flex flex-wrap" v-for="x in steps">
			<div @click="$emit('activeStep', x)" :class="{'active': step == x}" class="cursor-pointer skew px-5 step bg-white text-center px-12 py-2">
				<p class="font-semibold">{{word}} {{x}}</p>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	model: {
		prop: 'step',
		event: 'activeStep'
	},
	props: {
		word: {
			type: String,
			default: 'Step'
		},
		steps: {
			type: Number,
			required: true,
			default: 2
		},
		step: {
			type: Number,
			default: 1
		}
	},
	data () {
		return {
			active: 1
		}
	}
}
</script>
<style lang="scss" scoped>
.skew {
	clip-path: polygon(0% 0, 100% 0, 80% 100%, 0% 100%);
	border-radius: 5px
}
.unskew {
	transform: skewX(20deg) !important;
}

.steps {
	// border-width: thin;	
	> div {
		border-right-style: none
	}
	:not(:first-child) {
		border-left-style: none;
		margin-left: -25px;
		.step {
			// border-color: color(lms-tenant);
			clip-path: polygon(20% 0, 100% 0, 80% 100%, 0% 100%);
		}
	}


}

.active {
	background-color: color(lms-tenant);
	color: #fff;
}
</style>